export default {"src":"/_next/static/media/dog.b3513f9b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};